import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  signupData: {},
};

const signupSlice = createSlice({
  name: "signup",
  initialState,
  reducers: {
    setSignupData: (state, action) => {
      console.log("setSignupData", action.payload);
      state.signupData = action.payload;
    },
  },
});

export const { setSignupData } = signupSlice.actions;

export default signupSlice.reducer;

export const getSignupData = (state) => state.signup.signupData;
